/** Visible numerology tool copy per page language (/numerology vs /hi/numerology). */
export type NumerologyLanguage = "en" | "hi";

export const NUMEROLOGY_COPY = {
  en: {
    nameLabel: "Your Full Name",
    namePlaceholder: "Enter your full name",
    nameHint: "Used for Name Number calculation (Chaldean system)",
    dateLabel: "Birth Date",
    calculating: "Calculating...",
    submit: "Calculate My Numbers",
    error: "Something went wrong",
    mulankDescription:
      "Derived from your birth day. Reveals your core personality and natural tendencies.",
    bhagyankDescription: "Derived from your full birth date. Shows your life path and destiny.",
    nameNumberDescription:
      "Derived from your name using Chaldean mapping. Reflects your outer personality.",
    fullReading: "Get Full Kundali Reading",
    fullReadingHref: "/free-kundali/",
    again: "Calculate Again",
    ratingPrompt: "Was this numerology reading accurate?",
    luckyDay: "Lucky Day",
    gemstone: "Gemstone",
    compatible: "Compatible",
    rulingPlanet: "Ruling Planet",
    keyTraits: "Key Traits",
    luckyColors: "Lucky Colors",
    beejMantra: "Beej Mantra",
  },
  hi: {
    nameLabel: "आपका पूरा नाम",
    namePlaceholder: "अपना पूरा नाम लिखें",
    nameHint: "नामांक की गणना के लिए (कैल्डियन पद्धति)",
    dateLabel: "जन्म तिथि",
    calculating: "गणना हो रही है...",
    submit: "मेरे अंक निकालें",
    error: "गणना नहीं हो सकी। कृपया फिर से कोशिश करें।",
    mulankDescription: "जन्म के दिन से निकला अंक। आपका मूल स्वभाव और सहज प्रवृत्ति बताता है।",
    bhagyankDescription: "पूरी जन्म तिथि से निकला अंक। जीवन की दिशा और भाग्य दिखाता है।",
    nameNumberDescription: "कैल्डियन पद्धति से नाम का अंक। आपका बाहरी व्यक्तित्व दिखाता है।",
    fullReading: "पूरी कुंडली देखें",
    fullReadingHref: "/hi/free-kundali/",
    again: "फिर से गणना करें",
    ratingPrompt: "क्या यह अंक ज्योतिष परिणाम सही लगा?",
    luckyDay: "शुभ दिन",
    gemstone: "रत्न",
    compatible: "मित्र अंक",
    rulingPlanet: "स्वामी ग्रह",
    keyTraits: "मुख्य गुण",
    luckyColors: "शुभ रंग",
    beejMantra: "बीज मंत्र",
  },
} as const;

export type NumerologyCopy = (typeof NUMEROLOGY_COPY)[NumerologyLanguage];
